<template>
  <x-page
    title="秒杀专场"
    transparent-header
    white-back
    only-back
    :loading="loading"
  >
    <template v-if="!loading">
      <!-- 头部 -->
      <div :class="_.hd">
        <!-- 标题 -->
        <div
          :class="_.top"
          :style="{
            backgroundImage: `url(${require('./images/秒杀列表头部背景图.png')})`,
          }"
        >
          <x-icon
            :src="require('./images/秒杀列表头部标题.png')"
            :class="_.title"
          />
          <div :class="_.desc"></div>
        </div>

        <div
          v-if="!isEnded && seckillData.hasActivity"
          :class="[_.middle, _._hairlineBottom]"
        >
          <img :src="require('./images/日历.png')" :class="_.icon" />
          <div :class="_.content">
            <div :class="_.label">秒杀日期：</div>
            <div :class="_.value">
              {{ seckillDate }}
            </div>
          </div>
          <x-picker
            v-model="currentDate"
            v-track="{
              name: '选择日期',
              id: '49ad44a2-eee9-4bb4-9217-cab3e37c3225',
            }"
            title="选择日期"
            :class="_.select"
            :data="seckillDateData"
            :confirm-on-pick="true"
          >
            <div :class="_.container">
              <div :class="_.text">
                {{ formatDate(currentDate, true) }}
              </div>
              <img :src="require('./images/下拉箭头.png')" :class="_.arrow" />
            </div>
          </x-picker>
        </div>

        <!-- 时段 -->
        <!-- 仅非全天时显示时段栏 -->
        <div
          v-if="
            !isEnded &&
            seckillData.hasActivity &&
            sessionData.length &&
            !sessionData[0].isFull
          "
          :class="_.bottom"
        >
          <van-tabs v-model="sessionIndex" :class="_.tabs">
            <van-tab v-for="(item, index) in sessionData" :key="item.sessionId">
              <x-seckill-provider
                slot="title"
                :data="item"
                @change="seckillInfo => handleSeckillChange(seckillInfo, index)"
              >
                <template #default="{ seckillInfo }">
                  <div
                    v-track="{
                      name: '秒杀时段',
                      id: '901fb498-fe56-443c-9a45-fc55e325662d',
                      content: item.startTime,
                    }"
                    :class="[
                      _.item,
                      seckillInfo.isToday && _.today,
                      sessionIndex === index && _.current,
                      seckillInfo.isPending && _.pending,
                      seckillInfo.isRunning && _.running,
                      seckillInfo.isEnded && _.ended,
                    ]"
                  >
                    <div :class="_.time">
                      {{
                        seckillInfo.isFull
                          ? '全天'
                          : seckillInfo.formatStart('hh:ii')
                      }}
                    </div>
                    <div :class="_.status">
                      {{
                        seckillInfo.isPending
                          ? seckillInfo.isToday
                            ? '即将开抢'
                            : '未开始'
                          : seckillInfo.isRunning
                          ? '抢购中'
                          : '已结束'
                      }}
                    </div>
                  </div>
                </template>
              </x-seckill-provider>
            </van-tab>
            <van-tab />
          </van-tabs>
        </div>
      </div>

      <!-- 内容 -->
      <div
        v-if="!isEnded && seckillData.hasActivity && sessionData.length"
        :key="onlyAvailable"
        :class="_.bd"
      >
        <x-waterfall ref="list" :load="handleLoadData">
          <template #default="{ data }">
            <div
              v-for="item in data"
              :key="item.commodityId"
              v-track="{
                name: '秒杀商品',
                id: '2940c235-1610-49c0-a8d7-528186d8e843',
                mark: {
                  id: sessionData[sessionIndex].sessionId,
                  name: sessionData[sessionIndex].startTime,
                },
              }"
              :class="[
                _.item,
                item.surplusStock === 0 && _.sold,
                _[item.status],
              ]"
              @click="handleGoodsClick(item)"
            >
              <div :class="_.cover">
                <img :src="item.commodityCoverImg" :class="_.image" />
              </div>
              <div :class="_.content">
                <div :class="[_.name, _._ellipsis]">
                  {{ item.commodityTitle }}
                </div>
                <div :class="_.indicator">
                  <div :class="_.price">￥{{ item.dashPrice }}</div>
                  <div :class="_.allowance">
                    <div :class="_.label">补贴</div>
                    <div :class="_.label">
                      ￥{{ +(item.dashPrice - item.seckillPrice).toFixed(2) }}
                    </div>
                  </div>
                  <div :class="_.price">￥{{ item.dashPrice }}</div>
                </div>
                <div :class="_.button">
                  <div :class="_.price">
                    <div :class="_.value">
                      <span>￥</span
                      >{{
                        item.status === 'ended'
                          ? item.originalPrice
                          : item.seckillPrice
                      }}
                    </div>
                    <div :class="_.label">
                      {{ item.status === 'ended' ? '原价' : '秒杀价' }}
                    </div>
                  </div>
                  <div :class="_.action">
                    <div :class="_.top">
                      <template v-if="item.status === 'ended'">
                        立即购买
                      </template>
                      <template v-else-if="item.status === 'pending'">
                        未开始
                      </template>
                      <template v-else-if="item.status === 'running'">
                        抢购 <x-icon name="arrow" :class="_.arrow" />
                      </template>
                    </div>
                    <div v-hide-when-empty :class="_.bottom">
                      <template v-if="item.status === 'running'">
                        {{
                          item.surplusStock === 0
                            ? '已抢光'
                            : `剩余${item.surplusStock}件`
                        }}
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </x-waterfall>
      </div>
      <x-empty
        v-else
        message="活动已结束，看看其他好物吧~"
        :confirm-text="seckillData.buttonJumpLink ? '去逛逛' : ''"
        @confirm="handleBackHomeClick"
      />

      <!-- 回首页 -->
      <x-float-ad
        v-if="
          !isEnded &&
          seckillData.hasActivity &&
          sessionData.length &&
          seckillData.buttonImage &&
          seckillData.buttonJumpLink
        "
        v-track="{
          name: '更多好物',
          id: 'bbc3501f-300c-454a-b34d-e0d6c9ca4e3b',
        }"
        :image="seckillData.buttonImage"
        @click="handleBackHomeClick"
      />
    </template>
  </x-page>
</template>

<script>
  import Vue from 'vue'
  import { anyToDate, formatDate } from 'vtils/date'
  import {
    apiActivityActivityActivitySession,
    apiActivityActivityCommodityList,
    apiActivityActivityIndex,
  } from '@/api'
  import { dcb } from '@dcb/jssdk'
  import { defaultIndexTo } from 'vtils'
  import { getSeckillInfo, prepareData, submit } from '@/utils'
  import { navigateTo } from '@/router'
  import { Toast } from 'vant'

  export default Vue.extend({
    data: () => ({
      loading: false,

      id: '',
      currentDate: '',
      sessionIndex: 0,
      onlyAvailable: false,

      seckillDateData: [],
      seckillDate: '',
      seckillData: {},
      sessionData: [],

      isEnded: false,
    }),

    watch: {
      onlyAvailable() {
        // onlyAvailable 已作为列表的 key，它会重新渲染刷新，无需手动刷新，否则会导致请求多次
        // this.$reloadWaterfall('list')
      },
      sessionIndex() {
        this.$reloadWaterfall('list')
      },
      async currentDate() {
        await this.getSessions()
        this.$reloadWaterfall('list')
      },
    },

    created() {
      this.prepareData()
    },

    methods: {
      formatDate(date, noYear) {
        return formatDate(anyToDate(date), noYear ? 'm月d日' : 'yyyy年m月d日')
      },

      async prepareData() {
        this.loading = true
        const { seckillData } = await prepareData({
          seckillData: apiActivityActivityIndex(),
        })
        this.seckillData = seckillData
        if (!seckillData.hasActivity) {
          this.loading = false
          return
        }
        this.seckillDateData = seckillData.activityDates.map(item => ({
          label: this.formatDate(item),
          value: item,
        }))
        this.seckillDate = [
          this.formatDate(seckillData.activityDates[0]),
          seckillData.activityDates.length > 1 &&
            this.formatDate(
              seckillData.activityDates[seckillData.activityDates.length - 1],
              true,
            ),
        ]
          .filter(Boolean)
          .join('-')
        this.id = seckillData.activityId
        this.currentDate = seckillData.matchDate
        this.loading = false
      },

      async getSessions() {
        await submit(async $ => {
          $.start()
          const sessions = await apiActivityActivityActivitySession({
            date: this.currentDate,
          })
          this.sessionData = sessions.map(session => {
            return {
              ...session,
              ...getSeckillInfo(session),
            }
          })
          // 首先进行中的场次，其次即将开始的场次，最后第一场
          this.sessionIndex = defaultIndexTo(
            this.sessionData.findIndex(item => item.isRunning),
            defaultIndexTo(
              this.sessionData.findIndex(item => item.isPending),
              0,
            ),
          )
        })
      },

      // 暂不使用
      handleSessionChangeBefore(index) {
        if (getSeckillInfo(this.sessionData[index]).status === 'ended') {
          Toast('该场活动已结束')
          return false
        }
      },

      handleSeckillChange(seckillInfo, index) {
        // 当前选中的场次状态变化时刷新数据
        if (
          this.sessionIndex === index &&
          seckillInfo.prevStatus != null &&
          seckillInfo.prevStatus !== seckillInfo.status
        ) {
          this.$reloadWaterfall('list')
        }
      },

      async handleLoadData({ pageNumber }) {
        try {
          const data = await apiActivityActivityCommodityList(
            {
              activityId: this.id,
              pageIndex: pageNumber,
              pageSize: 10,
              sessionId: this.sessionData[this.sessionIndex].sessionId,
              type: this.onlyAvailable ? 2 : 1,
            },
            {
              noErrorToast: true,
            },
          ).then(res => {
            res.list = res.list.map(item => ({
              ...item,
              status: getSeckillInfo(this.sessionData[this.sessionIndex])
                .status,
            }))
            return res
          })
          return data
        } catch {
          this.isEnded = true
        }
      },

      handleGoodsClick(goods) {
        navigateTo('GoodsIndex', {
          id: goods.commodityId,
        })
      },

      handleBackHomeClick() {
        dcb.navigateTo({
          url: this.seckillData.buttonJumpLink,
        })
      },
    },
  })
</script>

<style lang="scss" module>
  .hd {
    position: sticky;
    top: 0;
    z-index: 100;

    .top {
      position: relative;
      padding-top: calc(var(--status-bar-height) + 12px);
      padding-bottom: 12px;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      text-align: center;
      font-size: 0;

      .title {
        width: 96px;
        height: 24px;
      }

      .desc {
        margin-top: 10px;
        font-size: 14px;
        color: #ffffff;
        line-height: 20px;
      }

      .button {
        position: absolute;
        top: calc(var(--status-bar-height) + 12px);
        right: 6px;
        height: 23px;
        background: #bb0000;
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        color: #ffffff;
        padding: 0 8px;

        &:active {
          filter: contrast(0.9);
        }
      }
    }

    .middle {
      margin-top: -12px;
      display: flex;
      align-items: center;
      background: linear-gradient(180deg, #fefbe7 0%, #ffffff 100%);
      border-radius: 15px 15px 0px 0px;
      padding: 12px 12px 12px 0;

      .icon {
        flex-shrink: 0;
        width: 47px;
        height: 32px;
      }

      .content {
        margin-left: 9px;
        flex-grow: 1;

        .label {
          font-size: 14px;
          color: #993f04;
          line-height: 20px;
        }

        .value {
          margin-top: 2px;
          font-size: 14px;
          font-weight: var(--bold-value);
          color: #993f04;
          line-height: 20px;
        }
      }

      .select {
        flex-shrink: 0;
        background: linear-gradient(180deg, #feefd8 0%, #fedfbb 100%);
        border-radius: 1000px;
        padding: 4px 12px;

        .container {
          display: flex;
          align-items: center;

          .text {
            font-size: 14px;
            font-weight: var(--bold-value);
            color: #993f04;
            line-height: 20px;
          }

          .arrow {
            margin-left: 3px;
            width: 12px;
            height: 12px;
          }
        }
      }
    }

    .bottom {
      .tabs {
        .item {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          .time {
            font-size: 22px;
            line-height: 26px;
            color: #333333;
            font-family: Bebas-Regular;
          }

          .status {
            margin-top: 4px;
            color: #999999;
            font-size: 12px;
            height: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0 6px;
            border-radius: 8px;
            background-color: transparent;
            white-space: nowrap;
          }

          &.ended {
            .time {
              color: #bebebe;
            }

            .status {
              color: #bebebe;
            }
          }

          &.current {
            .status {
              background: linear-gradient(131deg, #ff7e43 0%, #ff111c 100%);
              color: white;
            }

            &.today {
              .time {
                background: linear-gradient(131deg, #ff7e43 0%, #ff111c 100%);
                background-clip: text;
                color: transparent;
              }

              .status {
                background: linear-gradient(131deg, #ff7e43 0%, #ff111c 100%);
                color: white;
              }
            }
          }
        }

        :global {
          .van-tabs__wrap {
            height: 56px;
          }

          .van-tab {
            padding: 0 12px;

            + .van-tab::before {
              content: '';
              position: absolute;
              left: 0;
              top: 50%;
              width: 1px;
              height: 30px;
              border-left: 1px solid #d2d2d2;
              transform: translate(0, -50%);
            }

            &:nth-last-child(2) {
              flex: unset;
              flex-shrink: 0;
              width: 0;
              padding: 0;
              pointer-events: none;
              opacity: 0;

              &::before {
                content: none;
              }
            }
          }

          .van-tabs__nav {
            padding-right: 0;
            padding-left: 0;
          }

          .van-tabs__line {
            display: none;
          }

          .van-tab__text {
            font-size: 12px;
            font-weight: normal;
            color: #666666;
          }

          .van-tab--active .van-tab__text {
            font-size: 12px;
            color: #ff111c;
          }
        }
      }
    }
  }

  .bd {
    padding: 12px;

    .item {
      background: #ffffff;
      border-radius: 8px;
      padding: 12px;
      display: flex;
      align-items: stretch;

      + .item {
        margin-top: 12px;
      }

      .cover {
        flex-shrink: 0;
        width: 134px;
        height: 134px;
        border-radius: 8px;
        overflow: hidden;

        .image {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .content {
        margin-left: 12px;
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        overflow: hidden;

        .name {
          font-size: 16px;
          font-weight: var(--bold-value);
          color: #333333;
          line-height: 22px;
        }

        .indicator {
          position: relative;
          width: 100%;
          height: 50px;
          background-image: url('./images/秒杀价格指示器.png');
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;

          .price {
            position: absolute;
            left: 0;
            top: 10px;
            font-size: 11px;
            color: #ff8585;
            line-height: 16px;

            &:last-child {
              position: absolute;
              left: initial;
              right: 0;
              top: 10px;
            }
          }

          .allowance {
            position: absolute;
            left: 50%;
            top: 0;
            transform: translateX(-50%);
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            .label {
              font-size: 12px;
              font-weight: var(--bold-value);
              color: #ff111c;
              line-height: 17px;
            }

            .value {
              font-size: 12px;
              font-weight: var(--bold-value);
              color: #ff111c;
              line-height: 17px;
            }
          }
        }

        .button {
          position: relative;
          width: 100%;
          height: 46px;
          background-image: url('./images/秒杀按钮背景_秒杀中.png');
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;
          display: flex;
          align-items: center;

          .price {
            flex-shrink: 0;
            width: 62%;
            padding: 9px 0 5px 12px;
            font-size: 0;
            box-sizing: border-box;

            .value {
              font-size: 24px;
              font-family: Bebas-Regular;
              color: #ffffff;
              line-height: 16px;

              span {
                font-size: 12px;
                line-height: 17px;
              }
            }

            .label {
              font-size: 10px;
              color: #ffffff;
              line-height: 14px;
            }
          }

          .action {
            flex-grow: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            white-space: nowrap;

            .top {
              display: flex;
              align-items: center;
              font-size: 14px;
              font-weight: var(--bold-value);
              color: #ff111c;
              line-height: 20px;

              .arrow {
                font-size: 12px;
              }
            }

            .bottom {
              margin-top: 2px;
              font-size: 10px;
              color: #c08500;
              line-height: 14px;
            }
          }
        }
      }

      &.pending {
        .button {
          background-image: url('./images/秒杀按钮背景_未开始.png');

          .action {
            .top {
              color: white;

              .arrow {
                display: none;
              }
            }

            .bottom {
              display: none;
            }
          }
        }
      }

      &.sold {
        .cover {
          position: relative;

          &::after {
            content: '';
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            width: 110px;
            height: 110px;
            background-image: url('./images/秒杀已抢光封面.png');
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center;
          }
        }

        .button {
          background-image: url('./images/秒杀按钮背景_已抢光.png');

          .action {
            .top {
              color: #989898;
            }

            .bottom {
              color: #989898;
            }
          }
        }
      }

      &.ended {
        .cover {
          &::after {
            content: none;
          }
        }

        .indicator {
          background-image: url('./images/秒杀价格指示器_灰.png');

          .price {
            color: #c5c5c5;
          }

          .allowance {
            .label {
              color: #999999;
            }

            .value {
              color: #999999;
            }
          }
        }

        .button {
          background-image: url('./images/秒杀按钮背景_已结束.png');
        }
      }
    }
  }
</style>
